export const pathToLink = path => {
  return path === "#" || typeof path === "undefined" || path === "" || path === null ? "#" : `../${path}`;
};

export const isActive = (path, pathname) => {
  const [first, second, ...rest] = pathname.split("/"); // eslint-disable-line no-unused-vars
  const currentPath = rest.join("/");
  return path === currentPath;
}

export const activeColor = "#EFEFEF";

export const getColor = (path, pathname, paintAnyway = false, currentSection = null) => {
  return (currentSection === null && isActive(path, pathname)) || paintAnyway ? activeColor : null
};
